import { IServerErrorResponse } from '../../../types';
import { IMfaErrorData } from '../types';
import { MFA_REDIRECT_ERRORS, MFA_RELATED_ERRORS, MFA_STEPS_MAP } from '../helpers/constants';

export const handleOnAchOutError = (data: IServerErrorResponse): IMfaErrorData => {
  const errorCode = data?.response?.data?.errors?.[0]?.code;
  const { TAKE5, TOOK_A_BREAK, TAKE5_A } = MFA_REDIRECT_ERRORS;

  if (!errorCode || Number.isNaN(errorCode)) {
    return {
      stepToSwitch: null,
      shouldShowLocalErrorState: false,
      isExternalFlowError: false,
      errorCode,
      shouldShowGenericError: true,
    };
  }

  //* * Check if error is MFA related */
  if (MFA_RELATED_ERRORS.includes(errorCode)) {
    if (errorCode === TAKE5 || errorCode === TAKE5_A) {
      return {
        stepToSwitch: MFA_STEPS_MAP.TAKE_5,
        shouldShowLocalErrorState: false,
        isExternalFlowError: false,
        errorCode,
      };
    } if (errorCode === TOOK_A_BREAK) {
      return {
        stepToSwitch: MFA_STEPS_MAP.TOOK_A_BREAK,
        shouldShowLocalErrorState: false,
        isExternalFlowError: false,
        errorCode,
      };
    }
    return {
      stepToSwitch: null,
      shouldShowLocalErrorState: true,
      isExternalFlowError: false,
      errorMessage: data?.response?.data?.errors[0].localizedMessage || 'Service unavailable',
      errorCode,
    };
  }
  return {
    stepToSwitch: null,
    shouldShowLocalErrorState: false,
    isExternalFlowError: true,
    errorCode,
    rawErrorData: data,
  };
};
